import { useEffect, useRef, useState } from "react";
import { ChevronsUpDown, Package } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

export default function ItemMasterPicker({ onPick, testId }) {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const wrapperRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/item-masters"); setRows(data || []); }
      catch (e) { console.error("item-masters fetch fail", e); }
    })();
  }, []);

  useEffect(() => {
    function onDoc(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) { setOpen(false); setSearch(""); }
    }
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  useEffect(() => { if (open) setTimeout(() => inputRef.current?.focus(), 0); }, [open]);

  const s = search.toLowerCase();
  const filtered = rows.filter((r) =>
    (r.item_name || "").toLowerCase().includes(s) || (r.hsn || "").toLowerCase().includes(s) || (r.description || "").toLowerCase().includes(s));

  const pick = (r) => { onPick(r); setOpen(false); setSearch(""); };

  return (
    <div ref={wrapperRef} className="relative shrink-0">
      <Button type="button" variant="outline" size="sm" onClick={() => setOpen((o) => !o)} className="h-9 gap-1.5 text-xs" data-testid={testId}>
        <Package className="w-3.5 h-3.5" /> Saved item <ChevronsUpDown className="w-3 h-3 opacity-50" />
      </Button>
      {open && (
        <div className="absolute z-[60] top-full right-0 mt-1 w-[300px] bg-white border border-[#E2E8F0] rounded-md shadow-lg overflow-hidden">
          <div className="p-2 border-b border-[#E2E8F0]">
            <input ref={inputRef} value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search saved items…"
              className="w-full h-8 px-2 text-sm border border-[#E2E8F0] rounded outline-none focus:border-[#0055FF]" data-testid={`${testId}-input`} />
          </div>
          <div className="max-h-80 overflow-auto py-1">
            {filtered.length === 0 && <div className="px-3 py-2 text-sm text-muted-foreground">No saved items. Add them in Item Masters.</div>}
            {filtered.map((r) => (
              <button key={r.id} type="button" className="w-full text-left px-3 py-1.5 text-sm hover:bg-slate-50" data-testid={`${testId}-opt`}
                onClick={() => pick(r)}>
                <div className="flex items-center justify-between gap-2">
                  <span className="font-medium truncate">{r.item_name}</span>
                  <span className="font-mono text-xs text-[#0055FF] shrink-0">{`\u20B9${Number(r.rate || 0).toLocaleString("en-IN")}`}</span>
                </div>
                <div className="text-[11px] text-[#64748B] truncate">{r.hsn ? `HSN ${r.hsn} · ` : ""}Stock: {Number(r.quantity || 0)}{r.description ? ` · ${r.description}` : ""}</div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
